import {
  Box,
  SxProps,
  Theme,
  styled,
  IconButton,
  useTheme,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import React, { FunctionComponent } from "react";

export const SubHeading = styled(Box)(({ theme }) => {
  return {
    height: 48,
    marginBottom: 30,

    marginTop: 30,
    display: "flex",
    flexAlign: "flex-end",
  };
});
export const SubBar: FunctionComponent<{
  onAdd?: () => any;
  sx?: SxProps<Theme>;
  title?: string;
  titleAlign?: string;
  children?: React.ReactNode;
}> = ({ title, onAdd, sx, children, titleAlign }) => {
  const theme = useTheme();
  return (
    <SubHeading
      sx={{
        marginBottom: 0,
        ...(sx || {}),
        background: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      }}
    >
      <Box
        sx={{
          marginLeft: 1,
          alignSelf: titleAlign || "center",
          height: "48px",
          textAlign: "left",
          lineHeight: "48px",
        }}
      >
        {" "}
        {title}
      </Box>
      {children}
      {onAdd && (
        <Box
          sx={{
            alignSelf: "flex-end",
            marginLeft: "auto",
            marginBottom: "4px",
          }}
        >
          <IconButton
            size="small"
            sx={{
              background: theme.palette.success.light,
              color: theme.palette.success.contrastText,
              "&:hover": {
                background: theme.palette.success.main,
              },
              marginRight: 1,
            }}
            onClick={() => {
              onAdd && onAdd();
            }}
          >
            <AddIcon></AddIcon>
          </IconButton>
        </Box>
      )}
    </SubHeading>
  );
};
